// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1apPo","question":"Question_question__2r3p7","description":"Question_description__347oj"};